import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.28 14.358l1.944-.47c.157.65.395 1.276.708 1.864l-1.765.94a9.939 9.939 0 01-.887-2.334zm2.643 4.707l1.415-1.413a8.01 8.01 0 002.744 1.8l-.73 1.862a10.01 10.01 0 01-3.43-2.25zm5.799 2.854l.253-1.984c.338.043.68.065 1.025.065a7.976 7.976 0 005.954-2.657l1.488 1.337A9.975 9.975 0 0112 22c-.43 0-.856-.027-1.278-.081zm10.094-5.195l-1.762-.946A7.96 7.96 0 0020 12c0-1.137-.237-2.24-.69-3.254l1.827-.815c.567 1.27.863 2.65.863 4.069a9.96 9.96 0 01-1.184 4.724zm-.88-10.81l-1.587 1.218A8 8 0 004 12H2.001C2 6.477 6.477 2 12 2a9.983 9.983 0 017.935 3.914zM12 18a6 6 0 110-12 6 6 0 010 12zm0-2a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z"
    />
  </svg>
);
